import { render, staticRenderFns } from "./fkcode.vue?vue&type=template&id=7013d552&scoped=true"
import script from "./fkcode.vue?vue&type=script&lang=js"
export * from "./fkcode.vue?vue&type=script&lang=js"
import style0 from "./fkcode.vue?vue&type=style&index=0&id=7013d552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7013d552",
  null
  
)

export default component.exports